import { Observer } from 'mobx-react';
import * as React from 'react';

import { Distance } from 'src/models/distance';
import { DistanceHeader } from 'src/modules/racersTable/components';

import { data, generateIsBibs } from '../../derivations';
import { LeftSideSingleRow } from './LeftSideSingleRow';
import { LeftSideTeamRow } from './LeftSideTeamRow';

type Props = {
  distance: Distance;
};

const Rows = {
  single: LeftSideSingleRow,
  team: LeftSideTeamRow,
};

export const LeftSide: React.FC<Props> = (props) => {
  const { distance } = props;

  const distanceId = distance.value.id;
  const dataGenerator = data.generateDataEntries(distanceId);
  const isBibs = generateIsBibs(distanceId);
  const Row = Rows[distance.value.type];

  return (
    <Observer>
      {() => {
        const data: any[] = dataGenerator.get() || [];
        const withBibs = isBibs.get();

        return (
          <>
            <DistanceHeader name={distance.title()} />
            {data.map((item) => (
              <Row key={`table-lef-row-${item.id}`} withBibs={withBibs} value={item} />
            ))}
          </>
        );
      }}
    </Observer>
  );
};
